export default "__VITE_ASSET__CbvrC9ll__"